import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="schedule-calculator"
export default class extends Controller {
  static targets = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday", "totalHours", "startDate", "testDate", "resetButton"]

  connect() {
    // Set up event listeners for day inputs
    this.dayTargets.forEach(day => {
      day.addEventListener("input", () => this.calculate())
      day.addEventListener("change", () => this.calculate())
    })

    // Set up event listeners for date inputs to trigger reset
    if (this.hasStartDateTarget) {
      this.startDateTarget.addEventListener("change", () => this.triggerReset())
    }
    if (this.hasTestDateTarget) {
      this.testDateTarget.addEventListener("change", () => this.triggerReset())
    }
  }

  calculate() {
    if (!this.hasTotalHoursTarget) return

    let total = 0
    this.dayTargets.forEach(day => {
      const value = parseInt(day.value) || 0
      total += value
    })

    // Calculate hours (divide by 6.0 and round to 1 decimal)
    const hours = Math.round(total / 6.0) / 10.0
    this.totalHoursTarget.innerHTML = hours.toString()
  }

  triggerReset() {
    if (this.hasResetButtonTarget) {
      this.resetButtonTarget.click()
    }
  }

  get dayTargets() {
    const days = []
    if (this.hasMondayTarget) days.push(this.mondayTarget)
    if (this.hasTuesdayTarget) days.push(this.tuesdayTarget)
    if (this.hasWednesdayTarget) days.push(this.wednesdayTarget)
    if (this.hasThursdayTarget) days.push(this.thursdayTarget)
    if (this.hasFridayTarget) days.push(this.fridayTarget)
    if (this.hasSaturdayTarget) days.push(this.saturdayTarget)
    if (this.hasSundayTarget) days.push(this.sundayTarget)
    return days
  }
}
